<template lang="pug">
div
  .static-grid
    SectionTitle(
      :sectionText="data.partnerSectionText"
      :subtitleText='data.partnerSubtitleText'
      :displaySubtitleSection= 'true'
    )
    ul.static-partnerList2
      PartnerGrid(v-for='(info, idx) in infos'
        :key='idx'
        type="partners"
        :idx='idx + 1'
        :info='info'
      )

  .static-grid(v-if='eduInfos.length > 0')
    SectionTitle(
      :sectionText="data.eduSectionText"
      :displaySubtitleSection= 'true'
    )
    ul.static-partnerList2
      PartnerGrid(v-for='(info, idx) in eduInfos'
        :isEdu='true'
        :key='idx'
        :idx='idx + 1'
        :info='info'
        type="eduPartners"
      )

  .static-grid
    SectionTitle(
      :sectionText="data.govSectionText"
    )
    PartnerGrid(v-for='(info, idx) in govInfos'
      :key='idx'
      :idx='idx + 1'
      :info='info'
      type="govPartners"
    )
  
</template>

<script>
import SectionTitle from "@/components/modules/section_title/section_title.vue";
import PartnerGrid from "@/components/partner_grid/partner_grid.vue";
export default {
  components: {
    SectionTitle,
    PartnerGrid,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      infos: [],
      govInfos: [],
      eduInfos: []
    };
  },
  async created() {
    await this.getInfo();
    await this.getGovInfo();
    await this.getEduInfo();
  },
  methods: {
    async getInfo() {
      let route =
        this.$store.state.URLs.api +
        "/" +
        this.$store.state.lang +
        this.$store.state.routes.partners;
      let result = await this.$axios.get(route);
      this.infos = Object.values(result.data.content);
    },
    async getGovInfo() {
      let route =
        this.$store.state.URLs.api +
        "/" +
        this.$store.state.lang +
        this.$store.state.routes.govPartners;
      let result = await this.$axios.get(route);
      this.govInfos = Object.values(result.data.content);
    },
    async getEduInfo() {
      let route =
        this.$store.state.URLs.api +
        "/" +
        this.$store.state.lang +
        this.$store.state.routes.eduPartners;
      let result = await this.$axios.get(route);
      this.eduInfos = Object.values(result.data.content);
    },
  },
};
</script>
